export default "__VITE_ASSET__DVDa_Scv__"